import React, { FC, ChangeEvent } from "react";

import { FormSizes } from "~/constants/buttonAndForm";

type PropsType = {
  name: string;
  value?: string;
  defaultValue?: string;
  autoComplete?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  wrapperClassName?: string;
  rows?: number;
  size?: keyof typeof FormSizes;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
};

export const TextArea: FC<PropsType> = ({
  name,
  value,
  defaultValue,
  autoComplete,
  placeholder = "",
  required = false,
  disabled = false,
  className = "",
  wrapperClassName = "",
  rows = 7,
  size = "sm",
  onChange,
}: PropsType) => {
  return (
    <div className={`relative ${wrapperClassName}`}>
      <div
        style={{
          minHeight: rows + "rem",
        }}
        className={`${FormSizes[size]} ${className} overflow-hidden invisible break-keep whitespace-pre-wrap`}
        aria-hidden="true"
      >
        {value}\u200b
      </div>
      <textarea
        name={name}
        value={value}
        defaultValue={defaultValue}
        autoComplete={autoComplete}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        rows={rows}
        style={{
          minHeight: rows + "rem",
          font: "inherit",
        }}
        className={`${
          FormSizes[size]
        } absolute top-0 left-0 w-full h-full text-inherit overflow-hidden block resize-none border border-solid rounded focus:outline-none focus:border-secondary-400 placeholder-secondary-400 ${
          disabled ? "bg-secondary-300 text-secondary-600" : ""
        } ${className}`}
        onChange={onChange}
      />
    </div>
  );
};
